import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';
import EntryRosterReadOnlyContainer from './EntryRosterReadOnlyContainer.jsx';
import EntryRosterFormContainer from './EntryRosterFormContainer.jsx';

const EntryRosterModal = ({
  readOnly,
  visible,
  onCloseClick
}) =>(
  <StandardModal
    title="Entry and Roster Information"
    visible={visible}
    onCloseClick={onCloseClick}
    wideModal={true}
    bodyOverflow>
    <div>
      {readOnly
        ? <EntryRosterReadOnlyContainer />
        : <EntryRosterFormContainer />
      }
    </div>
  </StandardModal>
);

EntryRosterModal.propTypes = {
  readOnly: PropTypes.bool,
  visible: PropTypes.bool,
  onCloseClick: PropTypes.func
};

export default EntryRosterModal;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryRosterModal.jsx